import axiosInstance from "../Utils/axiosInstance";
import { JurisdictionApi } from "../Constants/api";

export const getJurisdictionsApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${JurisdictionApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
